import { reducer as pendingConfirmation } from "./queue/slice";

export const reducer = {
  pendingConfirmation,
};
